<template>
  <div :style="'background:#eee;overflow: hidden;height:' + clientHeight +'px'">
      <div ref="head">
      <Card :padding="0"  style="margin-bottom: 5px;" dis-hover>
        <Row type="flex" justify="start" align="middle" style="padding:5px 10px">
          <Col span="18">
            <Row type="flex" justify="start" align="middle">
              <ButtonToolBar
                ref="menutoolbar"
                :config="menuToolbar"
                :moduleMethod="moduleMethod"
                @doAction="doAction"
              />
            </Row>
          </Col>
          <Col span="6">
            <Row type="flex" justify="end" align="middle">
              <PromptMessage />
            </Row>
          </Col>
        </Row>
      </Card>
      </div>
    <Row type="flex" justify="start" >
      <Col :span="myConfig.gridCol" style="background:#eee;padding-right: 5px">
        <Card :padding="0" :bordered="false">
          <div style="padding-top:8px;padding-bottom:8px">
            <div ref="para">
            <Row type="flex" justify="start" align="middle" style="margin-bottom: 8px">
              <Col span="21" style="margin-left:30px">
                <QuickQueryToolbar
                  ref="quick"
                  :config="myConfig.quickQueryConfig"
                  :dictData="dictData"
                  @on-change="quickChagne"
                  :singleMode="true"
                />
              </Col>
            </Row>
            </div>
            <ViewGrid
              ref="grid"
              :config="myConfig.gridConfig"
              :dictData="dictData"
              @click="gridClick"
            />
          </div>
        </Card>
      </Col>
      <Col :span="myConfig.formCol" style="background:#eee">
        <Card :padding="0" :bordered="false" dis-hover >
          <BillDetailForm ref="form" :config="myConfig.detailConfig" :dictData="dictData" />
        </Card>
      </Col>
    </Row>
  </div>
</template>

<script>
import QuickQueryToolbar from './quickquerytoolbar.vue';
import PromptMessage from './promptmessage.vue';
import elementResizeDetectorMaker from 'element-resize-detector';
export default {
    name: 'leftlistrightdetails',
    components: { QuickQueryToolbar, PromptMessage },
    data() {
        return {
            myConfig: {
                showOperLog: false,
                operLogKey: 'billno',
                bindingKey: 'ph_key',
                resources: '',
                className: '',
                gridCol: 8,
                formCol: 16,
                formTitle: '详情',
                gridConfig: {},
                formConfig: {},
                adjustHeight: 160,
                quickQueryConfig: {}
            },
            menuToolbar: {
                enablePermissions: true,
                items: [
                    {
                        name: 'addData',
                        text: '新增'
                    },
                    {
                        name: 'editData',
                        text: '编辑'
                    },
                    {
                        name: 'saveData',
                        text: '保存'
                    },
                    {
                        name: 'delData',
                        text: '删除'
                    },
                    {
                        name: 'searchData',
                        text: '查询'
                    }
                ]
            },
            ph_key: ''
        };
    },
    props: {
        config: {
            type: Object,
            default: null
        },
        dictData: {
            type: Object,
            default: null
        },
        moduleMethod: {
            type: Array,
            default: () => {
                return [];
            }
        }
    },
    computed: {
        clientHeight () {
            return this.$Store.state.app.clientHeight;
        }
    },
    created() {
        this.myConfig = Object.assign({}, this.myConfig, this.config);
        this.myConfig.gridConfig.headStyle = '';
        this.myConfig.gridConfig.onSelectionChange = this.gridOnSelectionChange;
        this.myConfig.gridConfig.overrideData = this.gridOverrideData;
        this.myConfig.gridConfig.showCondition = false;
        this.myConfig.gridConfig.resources = this.myConfig.resources;
        this.myConfig.gridConfig.method = this.myConfig.classPrefix + '.search';
        this.myConfig.gridConfig.response = this.myConfig.response;
        this.myConfig.gridConfig.tableSize = 'small';
        this.myConfig.gridConfig.showBorder = false;
        this.myConfig.gridConfig.pageShowSizer = false;
        this.myConfig.gridConfig.height = 1;
        this.myConfig.gridConfig.adjustHeight = 0;
        this.myConfig.quickQueryConfig.filterConfig.showBtn = false;
        this.myConfig.quickQueryConfig.fuzzyQueryStyle = 'width:100%';
        if (this.myConfig.gridConfig.multiSelect === undefined) {
            this.myConfig.gridConfig.multiSelect = false;
        }
        this.myConfig.gridConfig.items.forEach(el => {
            if (el.type !== 'CheckBox') {
                if (el.tooltip === undefined) {
                    el.tooltip = true;
                }
            }
        });
    // 处理按钮
        if (this.myConfig.menuToolbar !== undefined) {
            for (let pro in this.myConfig.menuToolbar) {
                if (pro === 'items') {
                    if (this.myConfig.menuToolbar[pro].length > 0) {
                        this.menuToolbar[pro] = this.myConfig.menuToolbar[pro];
                    }
                } else {
                    this.menuToolbar[pro] = this.myConfig.menuToolbar[pro];
                }
            }
        }
        this.myConfig.detailConfig.titleType = 2;
        this.myConfig.detailConfig.showMenuToolbar = false;
        this.myConfig.detailConfig.showBillTitle = false;
        this.myConfig.detailConfig.response = this.myConfig.response;
        this.myConfig.detailConfig.adjustHeight = 0;
  
    // 处理日志
        if (this.myConfig.showOperLog) {
            this.myConfig.detailConfig.showOperLog = true;
            if (this.myConfig.operLogKey) {
                this.myConfig.detailConfig.operLogKey = this.myConfig.operLogKey;
            }
        }
        this.myConfig.detailConfig.resources = this.myConfig.resources;
    },
    methods: {
        search() {
            this.$refs.form.clearData();
            this.$refs.grid.clearSearchBeforeSearchParam();
            this.$refs.grid.setSearchBeforeSearchParam(this.getSearchParam());
            this.$refs.grid.refurbish();
        },
        getSearchParam() {
            return this.$refs.quick.getData();
        },
        refurbish(ph_key) {
            if (ph_key) {
                this.ph_key = ph_key;
            } else {
                this.ph_key = '';
            }
            this.$refs.form.clearData();
            this.$refs.grid.refurbish();
        },
        gridOnSelectionChange(rows) {
            let obj = {};
            obj.name = 'gridOnSelectionChange';
            obj.para = rows;
            this.$emit('doAction', obj);
        },
        gridOverrideData(data) {
            if (data && data.length > 0) {
                let self = this;
                this.$nextTick(() => {
                    let index = 0;
                    if (self.ph_key) {
                        let culIndex = data.findIndex(
              el => el[self.myConfig.bindingKey] === self.ph_key
            );
                        if (culIndex > -1) {
                            index = culIndex;
                        }
                    }
                    self.$refs.grid.setRowHighlight(index, true);
                    self.ph_key = data[index].ph_key;
                    self.initForm(data[index]);
                    self.$refs.menutoolbar.setAllReadOnly(false);
                    self.$refs.menutoolbar.setReadOnly('saveData', true);
                });
            } else {
                this.$refs.form.clearData();
                this.$refs.form.setReadOnly(true);
                this.$refs.menutoolbar.setAllReadOnly(true);
                this.$refs.menutoolbar.setReadOnly('addData', false);
            }
            return data;
        },
        gridClick(e) {
            let obj = {};
            let self = this;
            obj.onOk = () => {
                self.ph_key = e.ph_key;
                self.initForm(e);
                self.$refs.menutoolbar.setAllReadOnly(false);
                self.$refs.menutoolbar.setReadOnly('saveData', true);
            };
            obj.onCancel = () => {
                let data = self.$refs.form.getData();
                if (data.ph_key) {
                    let data = self.$refs.grid.getData();
                    let culIndex = data.findIndex(
            el => el[self.myConfig.bindingKey] === self.ph_key
          );
                    if (culIndex > -1) {
                        self.$refs.grid.clearCurrentRow();
                        self.$nextTick(() => {
                            self.$refs.grid.setRowHighlight(culIndex, true);
                        });
                    }
                } else {
                    self.$refs.grid.clearCurrentRow();
                }
            };
            this.checkData(obj);
        },
        getForm() {
            return this.$refs.form;
        },
        getGrid() {
            return this.$refs.grid;
        },
        quickChagne() {
            this.ph_key = '';
            this.search();
        },
        getMenuToolbar() {
            return this.$refs.menutoolbar;
        },
        initForm(para) {
            this.$refs.form.clearData();
            let data = this.getFormData(para);
            if (this.$parent.setBillData) {
                data = this.$parent.setBillData(data);
            }
            this.$refs.form.setData(data);
            this.$nextTick(() => {
                this.$refs.form.setReadOnly(true);
            });

            if (this.$parent.initFormAfter) {
                this.$parent.initFormAfter(data);
            }
        },
        getFormData(para) {
            let result = {};
            let self = this;
            if (!para.ph_key) {
                para.ph_key = this.ph_key;
            }
            self.synchroPost(
        self.myConfig.resources,
        self.myConfig.classPrefix + '.get',
        { ph_key: para.ph_key },
        function(data) {
            result = data[self.config.response];
        }
      );
            return result;
        },
        doAction(obj) {
            const method = obj.name;
            const methodBefore = method + 'Before';
            const methodAfter = method + 'After';
            if (
        obj.name === 'addData' ||
        obj.name === 'editData' ||
        obj.name === 'searchData'
      ) {
                let flag = true;
                if (this.$parent[methodBefore]) {
                    flag = this.$parent[methodBefore]();
                }
                if (flag) {
                    if (obj.name === 'addData') {
                        this.$refs.form.setReadOnly(false);
                        this.$refs.form.clearData();
                        this.$refs.menutoolbar.setAllReadOnly(true);
                        this.$refs.menutoolbar.setReadOnly('saveData', false);
                        this.$refs.grid.clearCurrentRow();
                    }
                    if (obj.name === 'editData') {
                        this.$refs.form.setReadOnly(false);
                        this.$refs.menutoolbar.setReadOnly('editData', true);
                        this.$refs.menutoolbar.setReadOnly('saveData', false);
                    }
                    if (obj.name === 'searchData') {
                        let temp = {};
                        let self = this;
                        temp.onOk = () => {
                            self.$refs.quick.filterSearch();
                        };
                        this.checkData(temp);
                    }

                    if (this.$parent[methodAfter]) {
                        this.$parent[methodAfter]();
                    }
                }
            } else {
                if (obj.name === 'saveData') {
                    let flag = this.$refs.form.checkValidate();
                    if (flag) {
                        this.alert('必填项不允许为空');
                        return false;
                    }
                    flag = this.$refs.form.isEdit();
                    if (flag) {
                        this.alert('存在数据未确认');
                        return false;
                    }
                    let data = this.$refs.form.getChangeData();
                    obj.para = [];
                    obj.para.push(data);
                }
                if (obj.name === 'delData') {
                    let tempData = this.$refs.grid.getSelection();
                    if (tempData && tempData.length > 0) {
                        tempData.forEach(el => {
                            el.flag = 'D';
                        });
                        obj.para = tempData;
                    } else {
                        this.alert('没有数据可删除，请检查');
                        return false;
                    }
                }
                obj.onOk = this.onOk;
                if (obj.name === 'delData') {
                    let self = this;
                    self.$Modal.confirm({
                        title: '确认',
                        content: '是否确认删除？',
                        onOk: () => {
                            self.$emit('doAction', obj);
                        }
                    });
                } else {
                    this.$emit('doAction', obj);
                }
            }
        },
        onOk(action, data) {
            if (action.name === 'saveData') {
                this.ph_key = data[0].ph_key;
                this.$refs.grid.refurbish();
                this.initForm(data[0]);
                this.$refs.menutoolbar.setReadOnly('editData', false);
                this.$refs.menutoolbar.setReadOnly('saveData', true);
            }
            if (action.name === 'delData') {
                this.ph_key = '';
                this.$refs.form.clearData();
                this.$refs.grid.refurbish();
                this.$refs.form.setReadOnly(true);
                this.$refs.menutoolbar.setAllReadOnly(false);
                this.$refs.menutoolbar.setReadOnly('saveData', true);
            }
        },
        checkData(obj) {
            let tempflag = false;
            tempflag = this.$refs.form.isEdit();
            if (tempflag) {
                let self = this;
                self.$Modal.confirm({
                    title: '确认',
                    content: '单据存在数据未确认，是否放弃？',
                    onOk: () => {
                        this.checkChangeData(obj);
                    },
                    onCancel: () => {
                        if (obj.onCancel) {
                            obj.onCancel();
                        }
                    }
                });
            } else {
                this.checkChangeData(obj);
            }
        },
        checkChangeData(obj) {
            let flag = false;
            flag = this.$refs.form.isChange();
            if (flag) {
                let self = this;
                self.$Modal.confirm({
                    title: '确认',
                    content: '单据有修改未保存，是否放弃修改？',
                    onOk: () => {
                        if (obj.onOk) {
                            obj.onOk();
                        }
                    },
                    onCancel: () => {
                        if (obj.onCancel) {
                            obj.onCancel();
                        }
                    }
                });
            } else {
                if (obj.onOk) {
                    obj.onOk();
                }
            }
        },
        setOutsideHeight () {
            let height = this.$refs.head.offsetHeight + this.$refs.para.offsetHeight + 32;
            this.$refs.grid.setOutsideHeight(height);
            let height2 = this.$refs.head.offsetHeight + 8;
            this.$refs.form.setOutsideHeight(height2);
        }
    },
    mounted() {
        this.observer = elementResizeDetectorMaker();
        this.observer.listenTo(this.$refs.head, this.setOutsideHeight);
        this.observer.listenTo(this.$refs.para, this.setOutsideHeight);
        this.$nextTick(() => {
            this.$refs.form.setReadOnly(true);
            this.$refs.menutoolbar.setAllReadOnly(false);
            this.$refs.menutoolbar.setReadOnly('saveData', true);
        });
    },
    beforeDestroy() {
        this.observer.removeListener(this.$refs.head, this.setOutsideHeight);
        this.observer.removeListener(this.$refs.para, this.setOutsideHeight);
    }
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/layouttemplate/leftlistrightdetails.vue